import React from "react";
import "../Styles/about.css"; // create this for styling

const About = () => {
  return (
    <div className="about-page">
      <h2 className="about-heading">About RCS</h2>

      <div className="about-section">
        <h3>Who We Are</h3>
        <p>
          RCS Top-Up & Billing Entity is a multi-service business based in
          Wakenaam, Essequibo. We proudly serve our community by offering a wide
          range of digital and financial solutions all in one location.
          With our every growing line of services, we aim to meet all your needs in one place!
        </p>
      </div>

      <div className="about-section">
        <h3>What We Do</h3>
        <p>
          From MMG+ agent transactions, mobile top-ups, and bill payments, to
          ferry pass bookings and business financial tools, our mission is to make
          your everyday financial needs easier and more convenient.
          <br /><br />
          RCS is the only MMG Superagent/Distributor in Wakenaam, Essequibo.
          RCS is also the sole autorized distriutor for Digicel, One Communication (Formerly GTT) and Enet- for both
          Topup (Wholesale & Retail) and phone cards. 
          <br /><br />
          RCS is also the sole Moneygram Agent in the vicinity, where we offer services as local and international 
          money transfer, and payment solutions to our seniors and public assisstance beneficiaries. 
        </p>
      </div>

      <div className="about-section">
        <h3>Our Commitment</h3>
        <p>
          We value reliability, integrity, and community — ensuring every
          interaction is professional, secure, and customer-focused.
        </p>
      </div>
    </div>
  );
};

export default About;
